import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-transportation-requests',
    templateUrl: './transportation-requests.component.html',
    styleUrls: ['./transportation-requests.component.scss']
})
export class TransportationRequestsComponent implements OnInit {
    constructor() {
    }

    ngOnInit() {
    }

}
